// AUTH index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    showAppViews: false,
    userLogged: false,
    token: localStorage.getItem('token') || '',
    info: null,
    subaccounts: [],
    activeSubaccount: JSON.parse(localStorage.getItem('subaccount')) || '',
  },
  actions,
  mutations,
  getters,
};
